import { INotificationSummary } from 'typings/notificationSummary';
import { DataManager } from 'utils/DataManager/dataManager';
import { INotificationDataManager } from 'typings/dataManagers';

class NotificationDataManager extends DataManager implements INotificationDataManager {
    baseUrl: string = '';

    setBaseUrl(url: string): string {
        this.baseUrl = url;
        return this.baseUrl;
    }

    getNotificationSummary(masterAccountId: string, cycleId: number): Promise<Nullable<INotificationSummary>> {
        const contextData = { cycleId };
        const receive = () => this._postDataRequest<typeof contextData, INotificationSummary>(
            `${this.baseUrl}/api/accounts/${masterAccountId}/notifications/product/teampay`,
            contextData);
        const dataOptions = {
            getDataFunc: receive,
            blockUi: false,
            ignoreFailure: true
        };
        try {
            return this.getDataWithOptions<INotificationSummary>(dataOptions);
        }
        catch (e) {
            return Promise.resolve({count: 0, notifications: [], timestamp: ''});
        }
    }

    async setLastReadNotifications(masterAccountId: string, timestamp: string | Date): Promise<void> {
        const receive = () => this._putDataRequest<typeof timestamp, void>(
            `${this.baseUrl}/api/accounts/${masterAccountId}/notifications/product/teampay`,
            timestamp);
        const dataOptions = {
            getDataFunc: receive,
            blockUi: false,
            ignoreFailure: true
        };
        await this.getDataWithOptions<void>(dataOptions);
    }
}

export { NotificationDataManager };
export default NotificationDataManager;